import React, { useState, useEffect } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TrendTable from './Table';
import Visualis from './Visualis';
import { useIntl } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    lineData,
    cardStatus,
    trendComputeType,
    trendCountValue,
    dateType,
    pageSortAttr,
    columnsList,
    segmentList,
    changeSegement,
    entityType,
    tabId,
    setChartLoading,
    chartLoading,
    trendCountMsg,
  } = props;

  // console.log('TrendsCard', props);
  const { digitalColumnsList } = useCompanyOptionList();

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  const [metricSegVal, setMetricSegVal] = useState(segmentList[0].value);
  const [metricSegValText, setMetricSegValText] = useState(segmentList[0].title ? segmentList[0].title : segmentList[0].text);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_trend` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-trends-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context dbi-mobileGames-title-custom"
        title={formatMessage({ id: `dbi_detail_trend` })}
        subTitle={`${trendCountMsg?.[metricSegVal]?.type} ${metricSegValText}: ${trendCountMsg?.[metricSegVal]?.value}`}
        activeTab={'line'}
        disableChartType={['bar', 'pie']}
      >
        <Segment
          value={metricSegVal}
          onChange={(value) => {
            /**切换segement时，更新聚合数据，更新可视化数据 */
            setMetricSegVal(value);
            const metricObj = segmentList?.find((item: any) => item.value == value);
            setMetricSegValText(metricObj.title || metricObj.text);
            if (changeSegement instanceof Function) {
              changeSegement(value);
            }
          }}
          options={segmentList}
        />
        <div className="trends-card-line">
          <Visualis
            chartType={'line'}
            dateType={dateType}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={metricSegVal}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-trend'}
            titleNow={metricSegValText}
            segmentList={segmentList}
            // lineSourceName={formatMessage({ id: `dbi_${entityType}` })}
          />
        </div>
        <TrendTable
          segementType={metricSegVal}
          tableData={tableData}
          dateType={dateType}
          pageSortAttr={pageSortAttr}
          columnsList={digitalColumnsList.trend[metricSegVal]}
          entityType={entityType}
        />
      </CardSlotV2>
    </div>
  );
};
export default TrendsCard;
